import script from "./ProfessionalForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__